export default {
    data() {
        return {
            leaveDialog: false,
            dirty: false,
            nextRoute: null,
            force: false
        };
    },
    async beforeRouteUpdate(to, from, next) {
        //comes from entity-from mixin
        //console.debug('route update!');
        //console.debug(this.dirty);
        // the second part handles the situation when this mixin is together with the entity-form mixin in one component
        if (!this.force && (this.dirty || (typeof this.isDirty === 'function' && await this.isDirty()))) {
            this.leaveDialog = true;
            this.nextRoute = to;
            next(false);
        } else {
            this.force = false;
            next();
        }
    },
    async beforeRouteLeave(to, from, next) {
        //comes from entity-from mixin
        //console.debug('route leave!');
        //console.debug(this.dirty);
        if (!this.force && (this.dirty  || (typeof this.isDirty ==='function' && await this.isDirty()))) {
            this.leaveDialog = true;
            this.nextRoute = to;
            next(false);
        } else {
            this.force = false;
            next()
        }
    },
    methods: {
        confirmLeave(answer) {
            //this.nextRoute(answer);
            if(answer) {
                this.force = true;
                this.$router.push(this.nextRoute);
            }
        }
    },
}